export default __webpack_public_path__ + "static/profile_compressed-950407690fddfdb7b7315625621bf3b8.mp4";